module.exports = __webpack_public_path__ + "img/dagang_title1.bb352acd.png";